import React from "react";
import { MessageCircle } from "lucide-react";
import { BRAND } from "../data/content";

export const WhatsappFab = () => (
  <a
    data-testid="whatsapp-fab"
    href={`https://wa.me/${BRAND.whatsapp}`}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Contactar por WhatsApp"
    className="fixed bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-[#25D366] text-white shadow-lg hover:bg-[#1da851] transition-colors duration-300"
  >
    <MessageCircle size={24} strokeWidth={1.8} />
  </a>
);
